(function ($, document, window) {
	'use strict';

	$(function () {
		const ctas = document.querySelectorAll('.js-call-to-action');

		function getCtaTitleHeight(card) {
			const title = card.querySelector('.js-call-to-action-title');

			if (!title) {
				return '100%';
			}

			const titleHeight = title.offsetHeight;
			return `calc(100% - ${(titleHeight / 16)}rem)`;
		}

		function getBannerHeight(card) {
			const banner = card.querySelector('.js-call-to-action-banner');

			if (!banner) {
				return `${60 / 16}rem`;
			}

			const bannerHeight = banner.offsetHeight;
			return `${(bannerHeight / 16) / 2}rem`;
		}

		ctas.forEach((cta) => {
			cta.style.setProperty('--card-translate-y', getCtaContentHeight(cta));
			cta.style.setProperty('--banner-adjustment', getBannerHeight(cta));

			const resizeObserver = new ResizeObserver(() => {
				cta.style.setProperty('--card-translate-y', getCtaContentHeight(cta));
				cta.style.setProperty('--banner-adjustment', getBannerHeight(cta));
			});

			resizeObserver.observe(cta);
		});
	});
})(jQuery, document, window);
